var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "form-checkbox" }, [
    _c("input", {
      staticClass: "form-checkbox__element",
      attrs: {
        type: "checkbox",
        name: _vm.name,
        required: _vm.required,
        disabled: "",
        checked: ""
      },
      on: { change: _vm.onChange }
    }),
    _c("span", { staticClass: "form-checkbox__icon" }),
    _vm.label
      ? _c("span", { staticClass: "form-checkbox__label" }, [
          _vm._v(_vm._s(_vm.label))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c4ce7fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4ce7fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FormCheckbox.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6c4ce7fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FormCheckbox.vue
// module chunks = 0 1 2